import { Component, Label, _decorator } from 'cc';
import { EDITOR } from 'cc/env';
import Dropdown from '../../Components/Dropdown/Dropdown';
import Page from '../../Components/Page/Page';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ColorTargetDropdown')
@requireComponent(Dropdown)
export default class ColorTargetDropdown<T extends Component = any> extends Component {
    @property
    private _targetClassName: string = '';

    private _dropdown: Dropdown = null;
    private _page: Page = null;
    private _targets: T[] = [];

    @property
    public get targetClassName(): string {
        return this._targetClassName;
    }
    public set targetClassName(value: string) {
        if (this._targetClassName === value) {
            return;
        }
        this._targetClassName = value;
        this.onTargetClassNameChanged();
    }

    public get currentTarget() {
        if (!this._targets.length) {
            return null;
        }
        return this._targets[this.dropdown.index];
    }

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown);
        }
        return this._dropdown;
    }

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    protected onLoad() {
        this.page.on(Page.EVENT_TYPE.OPEN_START, this.updateTargets, this);
    }

    protected onEnable() {
        this.onTargetClassNameChanged();
    }

    protected onTargetClassNameChanged() {
        if (EDITOR || !this.node.scene) {
            return;
        }
        this.updateTargets();
        // Default to last option because post-processing effects are usually on top of the scene
        this.dropdown.index = this._targets.length - 1;
    }

    protected updateTargets() {
        this._targets = this.node.scene.getComponentsInChildren(this.targetClassName) as T[];
        this.dropdown.init(
            this._targets.map((target) => target.node.name),
            (displayName, selectedOption) => {
                displayName.getComponent(Label).string = selectedOption;
            },
            (target, option) => {
                target.getComponentInChildren(Label).string = option;
            },
        );
    }
}
